export const mileData = {
  2020: ["ICY生态初成", "打造线下实体空间", "建立线下销售渠道"],
  2019: ["完成B轮融资", "产品出版社模式联动IP合作", "纽约时装周——吉服回潮"],
  2018: ["完成A轮融资", "“闯入”设计师商圈", "出征纽约时装周落地联名款"],
  2017: ["构建线上全渠道销售体系", "创新博主体系"],
};
